import DOMPurify from 'dompurify';

// Strip every tag and attribute. We're sanitizing form inputs before POSTing
// to the API, not rendering HTML — the safe output is plain text.
const STRIP_ALL = { ALLOWED_TAGS: [], ALLOWED_ATTR: [], KEEP_CONTENT: true };

/**
 * Sanitize a single string value.
 * Removes HTML tags, event handlers, and script content — leaves text only.
 */
export function sanitizeInput(value) {
  if (typeof value !== 'string') return value;
  return DOMPurify.sanitize(value, STRIP_ALL).trim();
}

/**
 * Sanitize all string values in a form data object.
 * Non-string values are passed through unchanged.
 */
export function sanitizeFormData(data) {
  if (!data || typeof data !== 'object') return data;

  const sanitized = {};
  for (const [key, value] of Object.entries(data)) {
    if (typeof value === 'string') {
      sanitized[key] = sanitizeInput(value);
    } else if (Array.isArray(value)) {
      sanitized[key] = value.map((item) =>
        typeof item === 'string' ? sanitizeInput(item) : item
      );
    } else {
      sanitized[key] = value;
    }
  }
  return sanitized;
}
